import { Model } from '../model';
import { Paginated } from '../paginated';

export class ResellerSubSenderAgcom extends Model {
  toAllSubaccounts: boolean;
  idUser: number;
  sender: string;
  idSender: number;
  status: any;
  enabledSMSQualities: Array<string>;
  lastNotifyAliasDate?: string;
  numeric: boolean;
  companyName: string;
  agcomTpoaAlias?: any;
}

export class ResellerAgcomSubSenders extends Paginated {
  data: Array<ResellerSubSenderAgcom>;
}
